import _ from 'lodash'
import createModel from 'utils/model'
import {
    getOrderList,
    importOrderByManual,
    editRemark,
    getFailedOrderlist,
    getIpSetting,
    resetIpSetting,
    setIpSetting,
} from 'app-self-support-order/services/order-import'
import {getShopList} from 'app-self-support-order/services/shop-manage'

function getInitFailParams() {
    return {
        limit: 10,
        offset: 0,
        order_no: undefined,
    }
}

export default createModel({
    namespace: 'selfSupportOrder_orderImport',
    state: {
        shops: [],
        params: {
            shop_id: '',
            status: '',
            begin_at: '',
            end_at: '',
            limit: 10,
            offset: 0,
        },
        list: [],
        total: 0,
        current: 1,
        // 失败订单
        failParams: getInitFailParams(),
        failList: [],
        failTotal: 0,
        failCurrent: 1,
        ipSettingObj: null,
    },
    effects: {
        // 获取订单
        *getOrderList({payload}, {select, call, put}) {
            const {params, current} = yield select(
                ({selfSupportOrder_orderImport}) => selfSupportOrder_orderImport,
            )
            const newParams = {...params, ...payload.params}

            if (payload.page) {
                newParams.offset = newParams.limit * (payload.page - 1)
            }

            const res = yield call(getOrderList, newParams)

            yield put({
                type: 'setProperty',
                payload: {
                    list: res.data,
                    params: newParams,
                    total: _.get(res, 'pagination.rows_found', 0),
                    current: _.get(payload, 'page', current),
                },
            })
        },

        // 手动导入订单
        *importOrderByManual({payload}, {call}) {
            return yield call(importOrderByManual, payload)
        },

        // 订单备注
        *editRemark({payload}, {call}) {
            return yield call(editRemark, payload)
        },

        // 失败订单列表
        *getFailedOrderlist({payload}, {select, call, put}) {
            const {failParams, failCurrent} = yield select(
                ({selfSupportOrder_orderImport}) => selfSupportOrder_orderImport,
            )
            const newParams = {...failParams, ...payload.params}

            if (payload.page) {
                newParams.offset = newParams.limit * (payload.page - 1)
            }

            const res = yield call(getFailedOrderlist, newParams)

            yield put({
                type: 'setProperty',
                payload: {
                    failList: res.data,
                    failParams: newParams,
                    failTotal: _.get(res, 'pagination.rows_found', 0),
                    failCurrent: _.get(payload, 'page', failCurrent),
                },
            })
        },

        // 获取店铺列表
        *getShopList(xxx, {put, call}) {
            const res = yield call(getShopList, {offset: 0, limit: 10000})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.shops = res.data
                },
            })
        },

        // 获取API订单接入-设置
        *getIpSetting(xxx, {put, call}) {
            const res = yield call(getIpSetting, {offset: 0, limit: 10000})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.ipSettingObj = res.data
                },
            })

            return res
        },

        // 重置API订单接入-设置
        *resetIpSetting(xxx, {call}) {
            return yield call(resetIpSetting)
        },

        // 设置API订单接入-设置
        *setIpSetting({payload}, {call}) {
            return yield call(setIpSetting, payload)
        },
    },

    reducers: {
        setParams(state, action) {
            const newParams = {
                ...state.params,
                ...action.payload,
            }

            return {...state, ...{params: newParams}}
        },
        resetFailParams(state) {
            return {...state, failParams: getInitFailParams()}
        },
    },
})
